import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UsersService as ApiUsersService } from 'src/app/api/services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private apiUsersService: ApiUsersService) {}

  canActivate(): Observable<boolean> {
    return this.apiUsersService.getMe$Response().pipe(
      map(response => {
        if (response.ok) { return true; }
        window.location.href = '/login';
        return false;
      }),
      catchError(() => {
        window.location.href = '/login';
        return of(false);
      })
    );
  }
}
